document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  var featuredHandle = params.get('featured');

  if (!featuredHandle) return;

  var collectionLoop = document.getElementById('CollectionLoop');
  if (!collectionLoop) return;

  var productLinks = collectionLoop.querySelectorAll('a.product-link[href*="/products/"]');
  if (!productLinks.length) return;

  var targetCard = null;

  productLinks.forEach(function (link) {
    var href = link.getAttribute('href') || '';

    if (href.indexOf('/products/' + featuredHandle) !== -1) {
      var card = link.closest('[data-grid-item]');
      if (card) {
        targetCard = card;
      }
    }
  });

  if (!targetCard) return;

  var productCards = collectionLoop.querySelectorAll('[data-grid-item]');
  if (!productCards.length) return;

  var firstCard = productCards[0];
  if (!firstCard || firstCard === targetCard) return;

  collectionLoop.insertBefore(targetCard, firstCard);
});